import { useCallback, useEffect, useState } from 'react';
import { useAppSelector } from '../redux/hook';
import { API_EndorseForm } from '../utils/api';
import { PolymerAxios } from '../utils/axios';
import { retry } from '../utils/retry';
import { P2Alert, P2TextLabel } from 'react-bootstrap-common-script';
import { LottieLoader } from '../components/loader';
import SuccessIconStageE from '../assets/svg/success-icon-stage-e';

const SignifyRedirect = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const endorseFormId = queryParameters.get('form');
  const applicationUuid = queryParameters.get('application');

  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<boolean | null>(null); // null = not attempted

  const triggerBackendUpdateViaProxy = useCallback(
    async (formId: number): Promise<boolean> => {
      const response = await PolymerAxios(loginUser?.uinfin ?? '', singpassToken, '', 'application/json', 0, '', true).post(
        `${API_EndorseForm}?formId=${formId}`,
        {
          applicationUuid: applicationUuid ?? '0',
        },
        {
          headers: {
            uinfin: 'redirect',
          },
        }
      );

      return response.status === 200;
    },
    [loginUser?.uinfin, singpassToken, applicationUuid, endorseFormId]
  );

  useEffect(() => {
    if (!endorseFormId) return;

    const fetch = async () => {
      setLoading(true);
      setSuccess(null);

      try {
        const result = await retry(() => triggerBackendUpdateViaProxy(parseInt(endorseFormId)), 3, 500);
        setSuccess(result);
      } catch (error) {
        console.error('All attempts failed:', error);
        setSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, [endorseFormId, triggerBackendUpdateViaProxy]);

  console.log(success);
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
      }}>
      {loading ? (
        <div>
          <LottieLoader />
          <P2TextLabel fontSize={'1.5rem'} bold={700} lineHeight={'24px'} label={`Please don’t close this page...`} />
        </div>
      ) : (
        <>
          {success === false ? (
            <P2Alert variant={'warning'} text={'Something went wrong while updating. Please refresh the page to try again or contact support.'} />
          ) : (
            <div className='d-flex gap-2 align-items-center justify-content-center' style={{ marginBottom: '1rem' }}>
              <SuccessIconStageE />
              <P2TextLabel fontSize={'1.5rem'} bold={700} lineHeight={'24px'} label={`You may now safely close this page.`} />
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default SignifyRedirect;
